import { ThemeUICSSObject, spacing } from '@apia/theme';
/* IMPORT HERE */

const buttonsBar: ThemeUICSSObject = {
  flexDirection: 'row',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: spacing(3),
  mb: spacing(0),
};

export default buttonsBar;
